import React from 'react';
import { Shield, Percent, Truck, Wrench, Sprout } from 'lucide-react';
const features = [{
  icon: Shield,
  title: 'Гарантия 3 года или 1500 моточасов',
  desc: 'Официальная гарантия 3 года или 1500 моточасов. Полное сервисное сопровождение.'
}, {
  icon: Percent,
  title: 'Лизинг',
  desc: 'Вся техника доступна для оформления в лизинг. Подберём оптимальные условия под вашу ситуацию.'
}, {
  icon: Truck,
  title: 'Доставка до места',
  desc: 'Доставляем в Алматы и Алматинскую область. Условия в другие регионы обсуждаются лично.'
}, {
  icon: Wrench,
  title: 'Сервис и оригинальные запчасти',
  desc: 'Собственный склад оригинальных запчастей Kubota. Ремонт и обслуживание.'
}];
export function WhyUs() {
  return <section className="bg-[#0A1A3F] text-white px-5 py-14 md:px-12 lg:px-24" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        {/* Small farms messaging */}
        <div className="text-center mb-3" data-id="element-142">
          <div className="inline-flex items-center gap-2 bg-[#228B22]/20 border border-[#228B22]/30 rounded-full px-4 py-1.5" data-id="element-143">
            <Sprout className="w-4 h-4 text-[#25D366]" data-id="element-144" />
            <span className="text-xs font-medium text-[#25D366]" data-id="element-145">
              Идеально для небольших хозяйств
            </span>
          </div>
        </div>

        <h2 className="font-heading font-bold text-[28px] md:text-[36px] text-center mb-3" data-id="element-146">
          Почему Профпарк?
        </h2>
        <p className="text-center text-white/60 text-sm md:text-base mb-8 max-w-lg mx-auto" data-id="element-147">
          Компактные и надёжные тракторы Kubota — лучший выбор для КХ, ТОО и
          небольших фермерских хозяйств.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5" data-id="element-148">
          {features.map(f => <div key={f.title} className="bg-white/8 border border-white/12 rounded-2xl p-5 md:p-6" data-id="element-149">
              <div className="w-11 h-11 rounded-xl bg-[#25D366]/15 flex items-center justify-center mb-4" data-id="element-150">
                <f.icon className="w-5 h-5 text-[#25D366]" data-id="element-151" />
              </div>
              <h3 className="font-heading font-bold text-base md:text-lg mb-1.5" data-id="element-152">
                {f.title}
              </h3>
              <p className="text-sm md:text-base text-white/65 leading-relaxed" data-id="element-153">
                {f.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}